import { metrics } from '@opentelemetry/api'

import { INSTRUMENTATION_NAME } from '../constants'

export const trackMemoryConsumption = () => {
    const performanceMemory = performance.memory

    // Only available in Chromium-based browsers
    if (!performanceMemory) return

    const meter = metrics.getMeter(INSTRUMENTATION_NAME)

    const memory = meter.createObservableGauge('app.js_heap_size', {
        description: 'JavaScript heap size (Chromium only)',
        unit: 'bytes',
    })

    memory.addCallback(result => {
        result.observe(performanceMemory.usedJSHeapSize, { 'heap.type': 'used' })
        result.observe(performanceMemory.totalJSHeapSize, { 'heap.type': 'total' })
        result.observe(performanceMemory.jsHeapSizeLimit, { 'heap.type': 'limit' })
    })
}
